import { agentRuntime, resetAgentConversation } from './agentClient';
import { clearCapabilityStore } from './capabilityStore';

// ---------------------------------------------------------------------------
// Shared mutable chat/table state
// ---------------------------------------------------------------------------
// Bridges the table action buttons, recheck flow and epic analysis so a crafted
// message/patch can be handed between the React components and the chat flow.
export const tableState = {
  // Tracks the latest recheck so its follow-up bot reply can offer an "add to table" button.
  lastRecheckCapability: "",
  // Coverage + matched API captured from the (hidden) recheck response marker.
  lastRecheckCoverage: "",
  lastRecheckApi: "",
  // Latest full epic coverage analysis, kept so a recheck can patch it locally.
  lastEpicAnalysis: "",
  // Last Azure DevOps work item id we loaded, so the analysis can be posted back to it.
  lastEpicId: "",
  showUpdateTableButton: false,
};

// Bridge so table action buttons can hand a crafted payload to the "action" flow block.
let pendingActionPayload = "";
export const setActionPayload = (payload: string) => { pendingActionPayload = payload; };
export const takeActionPayload = () => {
  const payload = pendingActionPayload;
  pendingActionPayload = "";
  return payload;
};

// Wipes all per-session chat/table state (notes, generated images and the cached
// epic analysis) from memory and localStorage. Called when a new session starts.
export const clearSessionData = () => {
  clearCapabilityStore();
  tableState.lastEpicAnalysis = "";
  tableState.lastEpicId = "";
  tableState.lastRecheckCapability = "";
  tableState.lastRecheckCoverage = "";
  tableState.lastRecheckApi = "";
  tableState.showUpdateTableButton = false;
  agentRuntime.agentMode = false;
  resetAgentConversation();
};
